module.exports = __webpack_public_path__ + "img/d- (18).fc9b55d8.png";